import _ from 'lodash';
import {TrackableEntity} from '../fms.core/data/ChangeTrackable';
import { IDictionary } from '../fms.core/data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import {LogFileDetail} from './document/LogFileDetail';
import { MemoComments } from './MemoComment';

export class Memo extends TrackableEntity {
    id: number = 0;
    memoType: string = '';
    jobName: string = '';
    tbName: string = '';
    jobId: number = 0;
    title: string = '';
    to: string = '';
    from: string = '';
    cc: string = '';
    description: string = '';
    isPublic: boolean = false;
    logFileId: number = 0;
    createdAt: string = '';
    createdBy: string = '';
    modifiedAt: string = '';
    modifiedBy: string = '';
    logFileDetails: LogFileDetail[] = [];
    pimsLinkId: number = 0;
    operator: string = '';
    creator: string = '';
    remind: string | null = null;
    remindDate: string | null = null;
    remindTime: string | null = null;
    due: string | null = null;
    dueDate: string | null = null;
    dueTime: string | null = null;
    addAsTaskReminder: boolean = false;
    reminderStatus: number = 1;
    tbType: string = '';
    
    bltbName: string = ''; 
    bltbId: number = 0;

    commentList: MemoComments[] = [];

    constructor(init?:Partial<Memo>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'jobName', 'to', 'from', 'cc', 'pimsLinkId');
        this.getdateProps.push('createdAt', 'modifiedAt'); 
        if(this.id === 0) this.id = this.GetNextId();

        if (this.commentList.length > 0) {
            this.commentList = this.commentList.map(d => new MemoComments(d));
        }else{
            this.commentList= [];
        }
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {

        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(Memo.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = Memo.dicFieldMappings[m];
        });

        _.keys(MemoComments.dicFieldMappings).forEach(m=>{
            dicFieldMap[`commentList.${m}`] = MemoComments.dicFieldMappings[m];
        });
        
        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_MEMO' }),
        'title': new DBMappingInfo({ field: 'F_TITLE', table: 'T_MEMO' }),
        'memoType': new DBMappingInfo({ field: 'F_MEMOTYPE', table: 'T_MEMO' }),
        'description': new DBMappingInfo({ field: 'F_CONTENTS', table: 'T_MEMO' }),
        'tbName': new DBMappingInfo({ field: 'F_TBNAME', table: 'T_MEMO' }),
        'jobId': new DBMappingInfo({ field: 'F_TBID', table: 'T_MEMO' }),
        'createdBy': new DBMappingInfo({ field: 'F_U1ID', table: 'T_MEMO' }),
        'createdAt': new DBMappingInfo({ field: 'F_U1Date', table: 'T_MEMO' }),
        'modifiedBy': new DBMappingInfo({ field: 'F_U2ID', table: 'T_MEMO' }),
        'modifiedAt': new DBMappingInfo({ field: 'F_U2Date', table: 'T_MEMO' }),
        'tbType': new DBMappingInfo({ field: 'F_TBType', table: 'T_MEMO' }),
    };

    setChildTrackable(value: boolean): void {
        if(this.commentList.length > 0) {
            this.commentList.forEach(c => c.trackable = value);
        }
    }
}
